<template>
    <el-container class="main-container" :class="{ 'is-mobile': isMobile }">
        <el-main class="data-container">
            <!-- 电脑端视图 -->
            <template v-if="!isMobile">
                <div class="desktop-toolbar">
                    <el-radio-group v-model="radio1" class="server-switch" @change="switchServer">
                        <el-radio-button label="CN Server" />
                        <el-radio-button label="US Server" />
                    </el-radio-group>

                    <div class="search-section">
                        <el-autocomplete v-model="serialNumber" :fetch-suggestions="querySearch" clearable
                            class="search-input" placeholder="请输入17位VIN" @select="handleSelect" maxlength="17"
                            show-word-limit type="text" @keyup.enter="fetchData" />
                        <el-button type="primary" @click="fetchData" class="search-btn">查询</el-button>
                    </div>

                    <div class="toolbar-tools">
                        <el-tag :type="loggedin === '已登录' ? 'success' : 'danger'" effect="light">{{ loggedin }}</el-tag>
                        <el-button size="small" :icon="Smoking" circle title="提交在线账号" @click="dialogFormVisible = true" />
                        <el-button size="small" :icon="EditPen" circle title="修改 HID" @click="handleGetHID()" />
                        <el-upload ref="uploadRef" :action="uploadActionUrl" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :on-error="handleAvatarError"
                            :before-upload="beforeAvatarUpload" :headers="uploadHeaders" class="upload-btn">
                            <el-button size="small" circle title="上传 T.txt">T</el-button>
                        </el-upload>
                    </div>
                </div>

                <div class="desktop-workspace">
                    <!-- 统计卡片区域 -->
                    <div class="stats-grid" v-loading="loading">
                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">收集总数</span>
                            </div>
                            <div class="stat-value">{{ collectTotal }}</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">未下载总数</span>
                                <el-popconfirm title="点击下载未爬取的所有VIN数据" @confirm="handleDownLoadVin()">
                                    <template #reference>
                                        <el-button size="small" :icon="Download" circle />
                                    </template>
                                </el-popconfirm>
                            </div>
                            <div class="stat-value">{{ notDownloaded }}</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">已爬取总数</span>
                            </div>
                            <div class="stat-value">{{ downloads }}</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">数据库容量</span>
                            </div>
                            <div class="stat-value">{{ dbcapacity }}</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">今日收集</span>
                            </div>
                            <div class="stat-value">{{ todayCollect }}</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">今日爬取</span>
                                <el-popconfirm title="后台启动爬取操作,仅爬取2026+的VIN" @confirm="handleDownLoadVin2()">
                                    <template #reference>
                                        <el-button size="small" :icon="Download" circle />
                                    </template>
                                </el-popconfirm>
                            </div>
                            <div class="stat-value">{{ todayUpdate }}</div>
                        </div>

                        <!-- 未匹配模板数 - 移除了highlight类，与其他卡片样式一致 -->
                        <div class="stat-card">
                            <div class="stat-header">
                                <span class="stat-title">未匹配模板数</span>
                                <div class="action-group">
                                    <el-button size="small" class="not-match-filter-button"
                                        @click="openNotMatchVinFilterDialog">过滤设置</el-button>
                                    <el-popconfirm title="确定要下载所有未匹配模板的 VIN 码吗？" @confirm="handleDownLoadVin3">
                                        <template #reference>
                                            <el-button size="small" :icon="Download" circle />
                                        </template>
                                    </el-popconfirm>
                                    <el-popconfirm title="确定要清空当前记录的数据吗？此操作不可撤销！" @confirm="handleClearVin">
                                        <template #reference>
                                            <el-button size="small" :icon="Delete" circle />
                                        </template>
                                    </el-popconfirm>
                                </div>
                            </div>
                            <div class="stat-value">{{ notmatchDeliver }}</div>
                        </div>

                        <div class="stat-card server-stat">
                            <div class="stat-header">
                                <span class="stat-title">当前服务器</span>
                            </div>
                            <div class="stat-value">{{ radio1 === 'CN Server' ? 'CN' : 'US' }}</div>
                        </div>
                    </div>

                    <!-- 主表格 -->
                    <div class="result-panel">
                        <div class="section-title">
                            <span>VIN 状态</span>
                        </div>
                        <el-table :data="filterTableData" v-loading="loading2" border stripe class="custom-table">
                            <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop"
                                :label="column.label" :width="column.width" header-align="center" align="center" />
                            <el-table-column label="操作" width="180" fixed="right">
                                <template #default="scope">
                                    <div class="table-actions">
                                        <el-popconfirm title="爬取数据" @confirm="handleRequest(scope.$index, scope.row)">
                                            <template #reference>
                                                <el-button size="small" type="success" :loading="btLoading">爬取</el-button>
                                            </template>
                                        </el-popconfirm>

                                        <el-popconfirm title="下载VM文件" @confirm="handleDownLoad(scope.$index, scope.row)">
                                            <template #reference>
                                                <el-button size="small" type="info">下载VM</el-button>
                                            </template>
                                        </el-popconfirm>

                                        <el-popconfirm title="下载加密文件" @confirm="handleDownLoad2(scope.$index, scope.row)">
                                            <template #reference>
                                                <el-button size="small" type="warning">下载加密</el-button>
                                            </template>
                                        </el-popconfirm>

                                        <el-upload ref="uploadRef1" :action="uploadActionUrl" :multiple="true"
                                            :show-file-list="false" :on-success="handleAvatarSuccess2"
                                            :before-upload="beforeAvatarUpload2" :headers="uploadHeaders" class="table-upload-action">
                                            <el-button size="small" type="primary" plain>上传数据</el-button>
                                        </el-upload>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- 诊断分支信息 -->
                    <div class="result-panel branch-panel" v-if="tableData2 && tableData2.length">
                        <div class="section-title">
                            <span>诊断分支</span>
                        </div>
                        <div class="branch-card-grid">
                            <div v-for="(item, index) in tableData2" :key="`${item.DiagMod || 'diag'}-${index}`" class="branch-card">
                                <div class="branch-summary">
                                    <div v-for="column in columns2" :key="column.prop" class="branch-row">
                                        <span>{{ column.label }}</span>
                                        <strong v-if="column.prop !== 'DiagMod'">{{ item[column.prop] || '-' }}</strong>
                                        <strong v-else class="diag-mode-value">
                                            {{ buildVinDiagModePresentation(item).text }}
                                            <el-tooltip v-if="buildVinDiagModePresentation(item).hasHint"
                                                :content="buildVinDiagModePresentation(item).hint" placement="top">
                                                <el-icon class="diag-mode-help" aria-label="查看诊断类型说明">
                                                    <QuestionFilled />
                                                </el-icon>
                                            </el-tooltip>
                                        </strong>
                                    </div>
                                </div>
                                <el-popconfirm title="仅处理投诉时使用，请勿用于开发调试!!!"
                                    @confirm="handleChangeDiagMod(index, item)">
                                    <template #reference>
                                        <el-button size="small" type="warning" plain>在线离线互转</el-button>
                                    </template>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>

                    <!-- 命令文本表格 -->
                    <div class="result-panel command-panel" v-if="tableData3 && tableData3.length">
                        <div class="section-title">
                            <span>命令文本数据</span>
                            <div class="title-actions">
                                <el-popconfirm title="确认删除?" @confirm="DeleteVindata()">
                                    <template #reference>
                                        <el-button size="small" type="danger">删除收集数据</el-button>
                                    </template>
                                </el-popconfirm>
                                <el-button size="small" type="primary" @click="SendCommandText()">
                                    下发命令文本
                                </el-button>
                            </div>
                        </div>
                        <el-table :data="tableData3" v-loading="loading2" border stripe class="custom-table">
                            <el-table-column v-for="column in columns3" :key="column.prop" :prop="column.prop"
                                :label="column.label" :width="column.width" header-align="center" align="center" />
                        </el-table>
                    </div>
                </div>
            </template>

            <!-- 手机端视图 -->
            <template v-else>
                <div class="mobile-view">
                    <!-- 顶部搜索卡片 -->
                    <div class="mobile-search-card">
                        <div class="mobile-search-header">
                            <h3 class="mobile-title">VIN数据管理</h3>
                            <el-tag size="small" effect="dark" class="server-tag">{{ radio1 }}</el-tag>
                        </div>
                        <div class="mobile-search-box">
                            <el-autocomplete v-model="serialNumber" :fetch-suggestions="querySearch" clearable
                                class="mobile-search-input" placeholder="请输入17位VIN" @select="handleSelect" maxlength="17"
                                show-word-limit type="text" />
                            <el-button type="primary" @click="fetchData" class="mobile-search-btn">查询</el-button>
                        </div>
                        <div class="mobile-tabs">
                            <el-button :type="radio1 === 'CN Server' ? 'primary' : 'default'" size="small" @click="switchServer('CN Server')">CN</el-button>
                            <el-button :type="radio1 === 'US Server' ? 'primary' : 'default'" size="small" @click="switchServer('US Server')">US</el-button>
                        </div>
                    </div>

                    <!-- 状态统计卡片 -->
                    <div class="mobile-stats-grid" v-loading="loading">
                        <div class="mobile-stat-card" @click="dialogFormVisible = true">
                            <div class="mobile-stat-icon">
                                <el-icon><Smoking /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">登录状态</span>
                                <span class="mobile-stat-value" :class="{
                                    'text-success': loggedin === '已登录',
                                    'text-error': loggedin !== '已登录'
                                }">{{ loggedin }}</span>
                            </div>
                        </div>

                        <div class="mobile-stat-card">
                            <div class="mobile-stat-icon">
                                <el-icon><DataLine /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">收集总数</span>
                                <span class="mobile-stat-value">{{ collectTotal }}</span>
                            </div>
                        </div>

                        <div class="mobile-stat-card" @click="handleDownLoadVin()">
                            <div class="mobile-stat-icon">
                                <el-icon><Download /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">未下载</span>
                                <span class="mobile-stat-value">{{ notDownloaded }}</span>
                            </div>
                        </div>

                        <div class="mobile-stat-card">
                            <div class="mobile-stat-icon">
                                <el-icon><Checked /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">已爬取</span>
                                <span class="mobile-stat-value">{{ downloads }}</span>
                            </div>
                        </div>

                        <div class="mobile-stat-card">
                            <div class="mobile-stat-icon">
                                <el-icon><Collection /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">数据库</span>
                                <span class="mobile-stat-value">{{ dbcapacity }}</span>
                            </div>
                        </div>

                        <div class="mobile-stat-card">
                            <div class="mobile-stat-icon">
                                <el-icon><Calendar /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">今日收集</span>
                                <span class="mobile-stat-value">{{ todayCollect }}</span>
                            </div>
                        </div>

                        <div class="mobile-stat-card" @click="handleDownLoadVin2()">
                            <div class="mobile-stat-icon">
                                <el-icon><TrendCharts /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">今日爬取</span>
                                <span class="mobile-stat-value">{{ todayUpdate }}</span>
                            </div>
                        </div>

                        <!-- 未匹配模板数 - 移除了highlight类，与其他卡片样式一致 -->
                        <div class="mobile-stat-card">
                            <div class="mobile-stat-icon">
                                <el-icon><Warning /></el-icon>
                            </div>
                            <div class="mobile-stat-content">
                                <span class="mobile-stat-label">未匹配模板</span>
                                <span class="mobile-stat-value">{{ notmatchDeliver }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 数据卡片列表 -->
                    <div class="mobile-data-section">
                        <div class="mobile-section-header">
                            <span>VIN数据列表</span>
                            <el-tag size="small">{{ filterTableData.length }}条</el-tag>
                        </div>
                        
                        <div v-if="filterTableData && filterTableData.length">
                            <div v-for="item in filterTableData" :key="item.Vin" class="mobile-data-card">
                                <div class="mobile-data-header">
                                    <span class="mobile-vin">{{ item.Vin }}</span>
                                    <el-tag :type="item.status === 'OK' ? 'success' : 'info'" size="small" round>{{ item.status }}</el-tag>
                                </div>
                                <div class="mobile-data-content">
                                    <div class="mobile-data-row">
                                        <span class="mobile-data-label">时间</span>
                                        <span class="mobile-data-value">{{ item.time }}</span>
                                    </div>
                                    <div class="mobile-data-row">
                                        <span class="mobile-data-label">模板</span>
                                        <span class="mobile-data-value">{{ item.deliver }}</span>
                                    </div>
                                    <div class="mobile-data-row">
                                        <span class="mobile-data-label">信息</span>
                                        <span class="mobile-data-value">{{ item.message }}</span>
                                    </div>
                                </div>
                                <div class="mobile-data-actions">
                                    <el-popconfirm title="爬取数据?" @confirm="handleRequest(0, item)">
                                        <template #reference>
                                            <el-button size="small" type="success" plain>爬取</el-button>
                                        </template>
                                    </el-popconfirm>
                                    <el-popconfirm title="下载VM?" @confirm="handleDownLoad(0, item)">
                                        <template #reference>
                                            <el-button size="small" type="info" plain>VM</el-button>
                                        </template>
                                    </el-popconfirm>
                                    <el-popconfirm title="下载加密?" @confirm="handleDownLoad2(0, item)">
                                        <template #reference>
                                            <el-button size="small" type="warning" plain>加密</el-button>
                                        </template>
                                    </el-popconfirm>
                                    <el-upload ref="uploadRef1" :action="uploadActionUrl" :show-file-list="false"
                                        :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2" :headers="uploadHeaders">
                                        <el-button size="small" type="primary" plain>上传</el-button>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                        <div v-else class="mobile-empty">
                            <el-empty description="暂无VIN数据" />
                        </div>
                    </div>

                    <!-- 诊断分支卡片 -->
                    <div class="mobile-data-section" v-if="tableData2 && tableData2.length">
                        <div class="mobile-section-header">
                            <span>诊断分支信息</span>
                        </div>
                        <div v-for="item in tableData2" :key="item.DiagMod" class="mobile-info-card">
                            <div class="mobile-info-row">
                                <span class="mobile-info-label">诊断分支</span>
                                <span class="mobile-info-value diag-mode-value">
                                    {{ buildVinDiagModePresentation(item).text }}
                                    <el-tooltip v-if="buildVinDiagModePresentation(item).hasHint"
                                        :content="buildVinDiagModePresentation(item).hint" placement="top">
                                        <el-icon class="diag-mode-help" aria-label="查看诊断类型说明">
                                            <QuestionFilled />
                                        </el-icon>
                                    </el-tooltip>
                                </span>
                            </div>
                            <div v-for="field in buildVinWmiMobileRows(item)" :key="field.key"
                                class="mobile-info-row">
                                <span class="mobile-info-label">{{ field.label }}</span>
                                <span class="mobile-info-value">{{ field.value }}</span>
                            </div>
                            <div class="mobile-info-row">
                                <span class="mobile-info-label">收集次数</span>
                                <span class="mobile-info-value">{{ item.scanCount }}</span>
                            </div>
                            <div class="mobile-info-row">
                                <span class="mobile-info-label">最近更新</span>
                                <span class="mobile-info-value">{{ item.dateStr }}</span>
                            </div>
                            <el-button size="small" type="warning" plain @click="handleChangeDiagMod(0, item)">在线离线互转</el-button>
                        </div>
                    </div>

                    <!-- 命令文本卡片 -->
                    <div class="mobile-data-section" v-if="tableData3 && tableData3.length">
                        <div class="mobile-section-header">
                            <span>命令文本数据</span>
                            <div class="header-actions">
                                <el-popconfirm title="确认删除?" @confirm="DeleteVindata()">
                                    <template #reference>
                                        <el-button size="small" type="danger" plain>删除</el-button>
                                    </template>
                                </el-popconfirm>
                                <el-button size="small" type="primary" plain @click="SendCommandText()">下发</el-button>
                            </div>
                        </div>
                        <div v-for="item in tableData3" :key="item.id" class="mobile-command-card">
                            <div class="command-row">
                                <span class="command-label">地址</span>
                                <span class="command-value">{{ item.address }}</span>
                            </div>
                            <div class="command-row">
                                <span class="command-label">PID</span>
                                <span class="command-value">{{ item.id }}</span>
                            </div>
                            <div class="command-row">
                                <span class="command-label">值</span>
                                <span class="command-value">{{ item.value }}</span>
                            </div>
                            <div class="command-row">
                                <span class="command-label">协议</span>
                                <span class="command-value">{{ item.prtl }}</span>
                            </div>
                            <div class="command-row">
                                <span class="command-label">故障码类型</span>
                                <span class="command-value">{{ item.spec }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 操作按钮组 -->
                    <div class="mobile-data-section mobile-action-section">
                        <div class="mobile-section-header">
                            <span>维护操作</span>
                        </div>
                        <div class="mobile-action-bar">
                            <el-button size="small" :icon="DataLine"
                                @click="openNotMatchVinFilterDialog">过滤设置</el-button>
                            <el-button size="small" :icon="EditPen" @click="handleGetHID()">修改HID</el-button>
                            <el-upload ref="uploadRef" :action="uploadActionUrl" :show-file-list="false"
                                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders">
                                <el-button size="small">上传T.txt</el-button>
                            </el-upload>
                            <el-button size="small" :icon="Download" @click="handleDownLoadVin3">下载未匹配VIN</el-button>
                            <el-button size="small" :icon="Delete" @click="handleClearVin">清空未匹配VIN</el-button>
                        </div>
                    </div>
                </div>
            </template>

            <!-- 弹窗组件保持不变 -->
            <el-dialog v-model="dialogFormVisible" title="提交在线账号" width="500px" class="custom-dialog">
                <el-form :model="form">
                    <el-form-item label="账号:" :label-width="formLabelWidth">
                        <el-input v-model="form.acc" autocomplete="off" />
                    </el-form-item>
                    <el-form-item label="密码:" :label-width="formLabelWidth">
                        <el-input v-model="form.password" type="password" autocomplete="off" />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">提交</el-button>
                    </span>
                </template>
            </el-dialog>

            <el-dialog v-model="notMatchVinFilterDialogVisible" title="未匹配模板下载过滤设置"
                width="min(440px, 92vw)" class="not-match-filter-dialog"
                :close-on-click-modal="!notMatchVinFilterSaving">
                <div v-loading="notMatchVinFilterLoading">
                    <el-alert title="设置将保存为当前用户的默认值，并用于后续下载。" type="info"
                        :closable="false" show-icon class="not-match-filter-tip" />
                    <el-form :model="notMatchVinFilterForm"
                        :label-position="isMobile ? 'top' : 'right'"
                        :label-width="isMobile ? 'auto' : '190px'">
                        <el-form-item label="最低年款">
                            <el-select v-model="notMatchVinFilterForm.minYear" style="width: 100%">
                                <el-option v-for="item in notMatchVinYearOptions" :key="item.value"
                                    :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="VIN 前3位必须符合 WMI">
                            <el-switch v-model="notMatchVinFilterForm.requireKnownWmi" />
                        </el-form-item>
                        <el-form-item label="过滤无效 WMI">
                            <el-switch v-model="notMatchVinFilterForm.excludeInvalidWmi" />
                        </el-form-item>
                    </el-form>
                </div>
                <template #footer>
                    <span class="not-match-filter-footer">
                        <el-button :disabled="notMatchVinFilterSaving"
                            @click="notMatchVinFilterDialogVisible = false">取消</el-button>
                        <el-button type="primary"
                            :disabled="!notMatchVinFilterReady || notMatchVinFilterLoading"
                            :loading="notMatchVinFilterSaving"
                            @click="saveNotMatchVinFilter">保存</el-button>
                    </span>
                </template>
            </el-dialog>

            <el-dialog v-model="dialogFormVisible2" title="修改登录账号使用的HID" width="500px" class="custom-dialog">
                <el-form :model="NewHid">
                    <el-form-item label="当前:" :label-width="formLabelWidth">
                        <el-input v-model="CurHid" autocomplete="off" disabled />
                    </el-form-item>
                    <el-form-item label="修改:" :label-width="formLabelWidth">
                        <el-input v-model="NewHid" autocomplete="off" />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="dialogFormVisible2 = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmitHID">提交</el-button>
                    </span>
                </template>
            </el-dialog>
        </el-main>
    </el-container>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, reactive } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus'
import { getVinInfo, downloadVinInfobyId, downloadVinInfobyId2, getVinStatus, requestVindata, DownLoadVM, DownLoadFCD, DownLoadJM, TryLoginTool, getVinKey, getHid, setHid, DownloadSomeOne, setSomeOne, Post_setSomeOne, getNotMatchVinDownloadFilter, saveNotMatchVinDownloadFilter, downloadNotMatchVinDeliv } from '../api/users';
import { Download, Smoking, EditPen, Delete, DataLine, Checked, Collection, Calendar, TrendCharts, Warning, QuestionFilled } from '@element-plus/icons-vue';
import {
    DEFAULT_NOT_MATCH_VIN_DOWNLOAD_FILTER,
    buildNotMatchVinYearOptions,
    isValidNotMatchVinDownloadFilter,
    normalizeNotMatchVinDownloadFilter,
} from '../utils/notMatchVinDownloadFilter.mjs';
import {
    VIN_WMI_STATUS_COLUMNS,
    buildVinDiagModePresentation,
    buildVinWmiMobileRows,
} from '../utils/vinWmiStatusPresentation.mjs';

export default {
    setup() {
        // 响应式判断手机端
        const isMobile = ref(window.innerWidth <= 768);
        
        const handleResize = () => {
            isMobile.value = window.innerWidth <= 768;
        };

        onMounted(() => {
            window.addEventListener('resize', handleResize);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });

        // 列配置 - 初始化所有数据
        const formLabelWidth = '60px';
        const dialogFormVisible = ref(false);
        const dialogFormVisible2 = ref(false);
        const CurHid = ref('Waiting for network request');
        const NewHid = ref('');
        const form = reactive({ acc: '', password: '' });
        
        const columns = ref([
            { prop: 'Vin', label: 'Vin', width: '200' },
            { prop: 'status', label: '状态', width: '100' },
            { prop: 'time', label: '时间', width: '180' },
            { prop: 'deliver', label: '模板', width: '130' },
            { prop: 'message', label: '信息' },
        ]);

        const columns2 = ref(VIN_WMI_STATUS_COLUMNS.map((column) => ({ ...column })));

        const columns3 = ref([
            { prop: 'address', label: '模块地址', width: '200' },
            { prop: 'id', label: 'PID', width: '100' },
            { prop: 'value', label: '值', width: '180' },
            { prop: 'prtl', label: '协议类型', width: '130' },
            { prop: 'spec', label: '故障码类型', width: '200' },
        ]);

        // 初始化所有数据为数组
        const tableData = ref([]);
        const tableData2 = ref([]);
        const tableData3 = ref([]);
        const search = ref('');
        
        const filterTableData = computed(() => {
            if (!tableData.value) return [];
            return tableData.value.filter(
                (data) =>
                    !search.value ||
                    (data.Vin && data.Vin.toLowerCase().includes(search.value.toLowerCase()))
            );
        });
        
        const cityData = ref({
            'CN Server': [],
            'US Server': []
        });

        const radio1 = ref('CN Server');
        const collectTotal = ref(0);
        const notDownloaded = ref(0);
        const notmatchDeliver = ref(0);
        const todayCollect = ref(0);
        const todayUpdate = ref(0);
        const downloads = ref(0);
        const dbcapacity = ref('');
        const loggedin = ref('未知');

        const notMatchVinFilterDialogVisible = ref(false);
        const notMatchVinFilterLoading = ref(false);
        const notMatchVinFilterSaving = ref(false);
        const notMatchVinFilterReady = ref(false);
        const notMatchVinFilterServer = ref('CN Server');
        const notMatchVinFilterForm = reactive({
            ...DEFAULT_NOT_MATCH_VIN_DOWNLOAD_FILTER,
        });
        const notMatchVinYearOptions = buildNotMatchVinYearOptions();

        const loading = ref(false);
        const loading2 = ref(false);
        const btLoading = ref(false);
        const serialNumber = ref('');
        const currentPage = ref(1);
        const pageSize = ref(20);
        const uploadedFileCount = ref(0);
        const isValidLength = ref(true);
        const recentQueries = ref(JSON.parse(localStorage.getItem('recentQueriesVinList')) || []);
        const uploadHeaders = ref({ Authorization: 'Bearer ' + localStorage.getItem("authToken") });
        const uploadRef = ref(null);
        const uploadRef1 = ref(null);

        const switchServer = (server) => {
            radio1.value = server;
            handleClick({ paneName: server });
        };

        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        
        const paginatedData = computed(() => {
            const start = (currentPage.value - 1) * pageSize.value;
            const end = currentPage.value * pageSize.value;
            return cityData.value[radio1.value] ? cityData.value[radio1.value].slice(start, end) : [];
        });

        const uploadActionUrl = computed(() => {
            return radio1.value === 'CN Server'
                ? 'https://diagapi.wwftool.top/api/v1/diag/UploadVinDataTxt'
                : 'https://diagapi.us.wwftool.top/api/v1/diag/UploadVinDataTxt';
        });

        // 相应函数
        const handleNothing = async (param) => {
            if (param === 0)
                uploadRef.value?.$el.querySelector('input').click();
            else if (param === 1)
                uploadRef1.value?.$el.querySelector('input').click();
        };

        // 处理上传成功的回调
        const handleAvatarSuccess = async (response, uploadFile) => {
            ElMessage.success('文件上传成功!(同步国内海外服务器)');
            const useBaseURL = radio1.value === 'CN Server';
            const response1 = await getVinInfo(useBaseURL);

            collectTotal.value = response1.data.collectTotal;
            notDownloaded.value = response1.data.notDownloaded;
            notmatchDeliver.value = response1.data.notmatchDeliver;
            loggedin.value = response1.data.loggedin;
            todayCollect.value = response1.data.todayCollect;
            todayUpdate.value = response1.data.todayUpdate;
            downloads.value = response1.data.downloads;
            dbcapacity.value = response1.data.dbcapacity;
            loading.value = false;
        };

        const handleAvatarError = () => {
            loading.value = false;
            ElMessage.error('文件上传失败，请重试');
        };

        const handleAvatarSuccess2 = async (response, uploadFile) => {
            uploadedFileCount.value += 1;

            if (uploadedFileCount.value < 2) {
                loading2.value = false;
                return;
            }

            uploadedFileCount.value = 0;

            if (!serialNumber.value || serialNumber.value.length !== 17) {
                ElMessage({
                    type: 'error',
                    message: '请输入一个17位的 VIN',
                });
                return;
            }

            loading2.value = true;
            ElMessage.success('文件上传成功!(仅上传当前服务器)');

            const serialNumberValue = serialNumber.value;
            const useBaseURL = radio1.value === 'CN Server';

            try {
                const vinRes = await getVinStatus(useBaseURL, serialNumberValue);

                if (vinRes.data.isnull) {
                    ElMessage({
                        type: 'warning',
                        message: '服务器无该VIN数据',
                    });
                } else {
                    columns.value = vinRes.data.columns || columns.value;
                    tableData.value = vinRes.data.tableData || [];
                    columns2.value = vinRes.data.columns2 || columns2.value;
                    tableData2.value = vinRes.data.tableData2 || [];
                    columns3.value = vinRes.data.columns3 || columns3.value;
                    tableData3.value = vinRes.data.tableData3 || [];
                }
            } catch (err) {
                console.error('获取 VIN 状态失败:', err);
                ElMessage.error('查询 VIN 状态失败');
            } finally {
                loading2.value = false;
            }
        };

        // 上传前检查文件类型和大小
        const beforeAvatarUpload = (rawFile) => {
            console.log('上传的文件名是:', rawFile.name);
            const isTtxt = rawFile.name.toLowerCase() === 't.txt';
            if (!isTtxt) {
                ElMessage.error('文件格式必须为 t.txt 格式！');
                return false;
            }
            loading.value = true;
            return true;
        };

        const beforeAvatarUpload2 = (rawFile) => {
            const isFeature = rawFile.name.includes('FeatureCodeDesc.txt');
            const isVehicle = rawFile.name.includes('VehicleModel.txt');

            if (!isFeature && !isVehicle) {
                ElMessage.error('必须上传 FeatureCodeDesc.txt 和 VehicleModel.txt 两个文件！');
                return false;
            }

            loading2.value = true;
            return true;
        };

        const handleClick = async (tab, event) => {
            loading.value = true;
            const useBaseURL = (tab.paneName === 'CN Server') ? true : false;
            try {
                const response = await getVinInfo(useBaseURL);
                collectTotal.value = response.data.collectTotal;
                notDownloaded.value = response.data.notDownloaded;
                notmatchDeliver.value = response.data.notmatchDeliver;
                loggedin.value = response.data.loggedin;
                todayCollect.value = response.data.todayCollect;
                todayUpdate.value = response.data.todayUpdate;
                downloads.value = response.data.downloads;
                dbcapacity.value = response.data.dbcapacity;
            } catch (error) {
                ElMessage.error('获取数据失败');
            } finally {
                loading.value = false;
            }
        };

        // 组件挂载时发起请求  
        onMounted(async () => {
            loading.value = true;
            try {
                const response = await getVinInfo(true);
                collectTotal.value = response.data.collectTotal;
                notDownloaded.value = response.data.notDownloaded;
                notmatchDeliver.value = response.data.notmatchDeliver;
                loggedin.value = response.data.loggedin;
                todayCollect.value = response.data.todayCollect;
                todayUpdate.value = response.data.todayUpdate;
                downloads.value = response.data.downloads;
                dbcapacity.value = response.data.dbcapacity;
            } catch (error) {
                ElMessage.error('初始化数据失败');
            } finally {
                loading.value = false;
            }
        });

        const handleDownLoadVin = async () => {
            try {
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                await downloadVinInfobyId(useBaseURL);
            } catch (error) {
                ElMessage({ type: 'error', message: '请求资源失败，请重试' });
            }
        };

        const handleDownLoadVin2 = async () => {
            try {
                if (loggedin.value != "已登录") {
                    return ElMessage({ type: 'error', message: '原厂账号未登录,请先完成登录操作!!!' });
                }
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                await downloadVinInfobyId2(useBaseURL);
                ElMessage({ type: 'success', message: '后台自动下载:请求成功' });
            } catch (error) {
                ElMessage({ type: 'error', message: '12小时后会再次开放操作' });
            }
        };

        const SendCommandText = async () => {
            try {
                const useBaseURL = (radio1.value === 'CN Server');
                const prtlSet = new Set(
                    (tableData3.value || [])
                        .map(item => item.prtl)
                        .filter(prtl => prtl)
                );

                for (const prtl of prtlSet) {
                    await DownloadSomeOne(
                        useBaseURL,
                        `downloadVinCmd?vin=${serialNumber.value}&prtl=${prtl}&deliver=${tableData.value[0]?.deliver || ''}`
                    );
                }

                ElMessage({ type: 'success', message: '请求下载Vin命令文本成功' });
            } catch (error) {
                ElMessage({ type: 'error', message: '请求下载Vin命令文本失败' });
            }
        };

        const DeleteVindata = async () => {
            try {
                await setSomeOne(radio1.value, serialNumber.value, 'DeleteCollectedVindata');
                ElMessage({ type: 'success', message: '删除Vin收集数据成功' });
            } catch (error) {
                ElMessage({ type: 'error', message: '删除Vin收集数据失败' });
            }
        };

        const notMatchFilterErrorMessage = (error, fallback) => {
            return error?.response?.data?.message || error?.info || error?.message || fallback;
        };

        const openNotMatchVinFilterDialog = async () => {
            notMatchVinFilterServer.value = radio1.value;
            Object.assign(notMatchVinFilterForm, DEFAULT_NOT_MATCH_VIN_DOWNLOAD_FILTER);
            notMatchVinFilterDialogVisible.value = true;
            notMatchVinFilterLoading.value = true;
            notMatchVinFilterReady.value = false;

            try {
                const useBaseURL = notMatchVinFilterServer.value === 'CN Server';
                const response = await getNotMatchVinDownloadFilter(useBaseURL);
                if (!isValidNotMatchVinDownloadFilter(response?.data)) {
                    throw new Error('服务器返回的过滤设置格式无效');
                }
                Object.assign(
                    notMatchVinFilterForm,
                    normalizeNotMatchVinDownloadFilter(response.data)
                );
                notMatchVinFilterReady.value = true;
            } catch (error) {
                ElMessage({
                    type: 'error',
                    message: notMatchFilterErrorMessage(error, '读取过滤设置失败，请重试')
                });
            } finally {
                notMatchVinFilterLoading.value = false;
            }
        };

        const saveNotMatchVinFilter = async () => {
            if (!notMatchVinFilterReady.value || notMatchVinFilterSaving.value) return;

            const useBaseURL = notMatchVinFilterServer.value === 'CN Server';
            const config = {
                minYear: notMatchVinFilterForm.minYear,
                requireKnownWmi: notMatchVinFilterForm.requireKnownWmi,
                excludeInvalidWmi: notMatchVinFilterForm.excludeInvalidWmi,
            };
            notMatchVinFilterSaving.value = true;
            try {
                await saveNotMatchVinDownloadFilter(useBaseURL, config);
                notMatchVinFilterDialogVisible.value = false;
                ElMessage({
                    type: 'success',
                    message: '过滤设置已保存'
                });
            } catch (error) {
                ElMessage({
                    type: 'error',
                    message: notMatchFilterErrorMessage(error, '保存过滤设置失败，请重试')
                });
            } finally {
                notMatchVinFilterSaving.value = false;
            }
        };

        const handleDownLoadVin3 = async () => {
            try {
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                await downloadNotMatchVinDeliv(useBaseURL);
            } catch (error) {
                ElMessage({
                    type: 'error',
                    message: notMatchFilterErrorMessage(error, '请求资源失败，请重试')
                });
            }
        };

        const handleClearVin = async () => {
            try {
                await setSomeOne(radio1.value, '', 'deleteNotMatchVinDeliv');
                notmatchDeliver.value = '0';
            } catch (error) {
                ElMessage({ type: 'error', message: '清除失败，请重试' });
            }
        };

        const handleRequest = async (index, row) => {
            try {
                if (row.status == "OK") {
                    return ElMessage({ type: 'error', message: '数据已存在,无需爬取!!!' });
                }
                if (loggedin.value != "已登录") {
                    return ElMessage({ type: 'error', message: '账号未登录,请联系开发登录爬虫账号' });
                }

                const value = row.Vin;
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                btLoading.value = true;
                await requestVindata(useBaseURL, value);
                ElMessage({ type: 'success', message: '已发送请求,建议在20后再次查询结果' });
                await delay(20000);
            } catch (error) {
                if (error.status == 400) {
                    ElMessage({ type: 'error', message: '未登录账号!!!' });
                } else {
                    ElMessage({ type: 'error', message: '请求资源失败，请重试' });
                }
            } finally {
                btLoading.value = false;
            }
        };

        const handleDownLoad = async (index, row) => {
            try {
                if (row.status == "FINISH") {
                    return ElMessage({ type: 'error', message: '先在<数据转存>菜单中删除上传记录.' });
                } else if (row.status != "OK") {
                    return ElMessage({ type: 'error', message: '数据不存在,请先完成爬取操作' });
                }

                const value = row.Vin;
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                await DownLoadVM(useBaseURL, value);
                await DownLoadFCD(useBaseURL, value);
                ElMessage({ type: 'success', message: '下载成功' });
            } catch (error) {
                ElMessage({ type: 'error', message: '请求资源失败，请重试' });
            }
        };

        const handleChangeDiagMod = async (index, row) => {
            try {
                if (row.DiagMod == "江铃软件") {
                    return ElMessage({ type: 'error', message: '江铃软件不支持转换' });
                } else if (row.DiagMod == "在线结构-仅模板") {
                    return ElMessage({ type: 'error', message: '仅模板类型,不支持转换' });
                } else if ((row.DiagMod != "在线结构") && (row.DiagMod != "离线结构")) {
                    return ElMessage({ type: 'error', message: '数据不存在,不支持转换' });
                }

                const Mod = (row.DiagMod == "在线结构") ? "FDRS" : "IDS";
                const form = { "Vin": tableData.value[0]?.Vin, "DiagMod": Mod, "deliver": tableData.value[0]?.deliver };
                
                const response = await Post_setSomeOne(radio1.value, form, 'ChangeDiagMod');
                tableData2.value = response.data.tableData2 || [];
                ElMessage.success(`已同步到CN,US服务器中`);//`已同步到${radio1.value}中`
            } catch (error) {
                ElMessage({ type: 'error', message: '修改数据失败，请重试' });
            }
        };

        const handleDownLoad2 = async (index, row) => {
            try {
                if (row.status == "FINISH") {
                    return ElMessage({ type: 'error', message: '先在<数据转存>菜单中删除上传记录.' });
                } else if (row.status != "OK") {
                    return ElMessage({ type: 'error', message: '数据不存在,请先完成爬取操作' });
                }

                const value = row.Vin;
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                await DownLoadJM(useBaseURL, value);
                ElMessage({ type: 'success', message: '下载成功' });

                const response = await getVinKey(useBaseURL, value);
                ElMessageBox.alert(response.data.vinkey, 'VinKey', {
                    confirmButtonText: 'OK',
                });
            } catch (error) {
                ElMessage({ type: 'error', message: '请求资源失败，请重试' });
            }
        };

        const fetchData = async () => {
            const serialNumberValue = (serialNumber.value && serialNumber.value.length === 17) ? serialNumber.value : "all";
            const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            
            if (!serialNumber.value || serialNumber.value.length !== 17) {
                ElMessage({ type: 'error', message: '请输入一个17位的Vin' });
                return;
            }
            
            loading2.value = true;
            try {
                const response = await getVinStatus(useBaseURL, serialNumberValue);
                if (response.data.isnull) {
                    ElMessage({ type: 'warning', message: '服务器无该VIN数据' });
                    tableData.value = [];
                    tableData2.value = [];
                    tableData3.value = [];
                } else {
                    columns.value = response.data.columns || columns.value;
                    tableData.value = response.data.tableData || [];
                    columns2.value = response.data.columns2 || columns2.value;
                    tableData2.value = response.data.tableData2 || [];
                    columns3.value = response.data.columns3 || columns3.value;
                    tableData3.value = response.data.tableData3 || [];
                }

                if (serialNumber.value.length === 17) {
                    updateRecentQueries(serialNumberValue);
                }
            } catch (error) {
                ElMessage.error('请求失败，请重试');
            } finally {
                loading2.value = false;
            }
        };

        const handleSubmit = async () => {
            try {
                if (!form.acc || !form.password) {
                    ElMessage({ type: 'warning', message: '账号、密码不能为空' });
                    return;
                }
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                const olacc = { acc: form.acc, password: form.password };
                loading.value = true;
                dialogFormVisible.value = false;
                await TryLoginTool(useBaseURL, olacc);
                ElMessage({ type: 'success', message: '已同步到CN/US服务器中' });
                loggedin.value = '已登录';
                form.acc = '';
                form.password = '';
            } catch (error) {
                ElMessage({ type: 'warning', message: '请求登录账号失败，请重试' });
            } finally {
                loading.value = false;
            }
        };

        const handleSubmitHID = async () => {
            try {
                if (NewHid.value.length !== 28) {
                    ElMessage({ type: 'error', message: '请输入一个28位的Hid' });
                    return;
                }

                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                dialogFormVisible2.value = false;
                await setHid(useBaseURL, NewHid.value);
                ElMessage({ type: 'success', message: '设置HID成功' });
            } catch (error) {
                ElMessage({ type: 'warning', message: '设置HID失败，请重试' });
            }
        };

        const handleGetHID = async () => {
            try {
                dialogFormVisible2.value = true;
                const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                const response = await getHid(useBaseURL);
                CurHid.value = response.data.hid;
                NewHid.value = response.data.hid;
            } catch (error) {
                ElMessage({ type: 'warning', message: '获取HID失败，请重试' });
                dialogFormVisible2.value = false;
            }
        };

        const updateRecentQueries = (query) => {
            const index = recentQueries.value.findIndex(item => item.value === query);
            if (index !== -1) {
                recentQueries.value.splice(index, 1);
            }
            recentQueries.value.unshift({ value: query });
            if (recentQueries.value.length > 5) {
                recentQueries.value.pop();
            }
            localStorage.setItem('recentQueriesVinList', JSON.stringify(recentQueries.value));
        };

        const handleSelect = (item) => {
            updateRecentQueries(item.value);
        };

        const querySearch = (queryString, cb) => {
            cb(recentQueries.value);
        };

        return {
            isMobile,
            switchServer,
            columns, tableData, columns2, tableData2, columns3, tableData3,
            filterTableData,
            currentPage,
            pageSize,
            paginatedData,
            serialNumber, recentQueries,
            isValidLength,
            fetchData,
            loading, loading2, btLoading,
            radio1,
            cityData,
            querySearch, search,
            handleSelect,
            handleClick, handleDownLoad, handleDownLoad2,
            Download, Smoking, EditPen, Delete, DataLine, Checked, Collection, Calendar, TrendCharts, Warning, QuestionFilled,
            handleDownLoadVin, handleDownLoadVin2, handleDownLoadVin3, handleRequest,
            collectTotal, notDownloaded, notmatchDeliver, todayCollect, todayUpdate, downloads, dbcapacity, loggedin,
            notMatchVinYearOptions,
            notMatchVinFilterDialogVisible, notMatchVinFilterLoading, notMatchVinFilterSaving,
            notMatchVinFilterReady, notMatchVinFilterForm,
            openNotMatchVinFilterDialog, saveNotMatchVinFilter,
            buildVinWmiMobileRows,
            buildVinDiagModePresentation,
            dialogFormVisible, dialogFormVisible2, formLabelWidth, form, handleSubmit, ElMessageBox,
            CurHid, NewHid, handleGetHID, handleSubmitHID, uploadHeaders,
            handleClearVin, handleChangeDiagMod, handleNothing, uploadRef, uploadRef1, handleAvatarSuccess, beforeAvatarUpload, beforeAvatarUpload2,
            handleAvatarError, handleAvatarSuccess2, uploadedFileCount, uploadActionUrl, DeleteVindata, SendCommandText
        };
    },
};
</script>

<style scoped>
/* 电脑端样式 */
.main-container {
    height: 100vh;
    background: #eef2f6;
}

.data-container {
    padding: 18px;
    height: 100%;
    overflow-y: auto;
}

/* 桌面顶部工具栏 */
.desktop-toolbar {
    background: white;
    border: 1px solid #dbe3ee;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 12px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
    display: grid;
    grid-template-columns: auto minmax(360px, 1fr) auto;
    gap: 14px;
    align-items: center;
}

.server-switch {
    white-space: nowrap;
}

.server-switch :deep(.el-radio-button__inner) {
    min-width: 94px;
    font-weight: 600;
}

.desktop-workspace {
    background: white;
    border: 1px solid #dbe3ee;
    border-radius: 8px;
    padding: 14px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.search-section {
    display: flex;
    align-items: center;
    justify-self: stretch;
    min-width: 0;
}

.search-input {
    width: 100%;
}

.search-input :deep(.el-input__wrapper) {
    border-radius: 6px 0 0 6px;
    border-right: none;
    box-shadow: 0 0 0 1px #cfd8e3 inset;
}

.search-btn {
    border-radius: 0 6px 6px 0;
    padding: 10px 20px;
}

.toolbar-tools {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
}

.upload-btn {
    display: inline-flex;
}

/* 统计卡片网格 */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0;
    margin-bottom: 10px;
    border: 1px solid #dbe3ee;
    border-radius: 8px;
    overflow: hidden;
}

.stat-card {
    background: #f8fafc;
    border-right: 1px solid #e4eaf2;
    padding: 8px 12px;
    min-height: 58px;
    transition: all 0.2s ease;
    min-width: 0;
}

.stat-card:nth-child(4n) {
    border-right: 0;
}

.stat-card:nth-child(n + 5) {
    border-top: 1px solid #e4eaf2;
}

.stat-card:hover {
    background: #fff;
}

.stat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 6px;
    min-height: 22px;
}

.stat-title {
    font-size: 12px;
    color: #64748b;
    font-weight: 600;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stat-value {
    font-size: 20px;
    line-height: 1.15;
    font-weight: 700;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.stat-value.status-success {
    color: #61bc84;
}

.stat-value.status-error {
    color: #fd5732;
}

.action-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4px;
}

.not-match-filter-button {
    min-width: 82px;
}

/* 结果区 */
.result-panel {
    background: #fff;
    border: 1px solid #dbe3ee;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 10px;
}

.section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    min-height: 34px;
    padding: 5px 14px;
    border-bottom: 1px solid #e4eaf2;
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
}

.title-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

.custom-table {
    border-radius: 0;
    overflow: hidden;
    box-shadow: none;
}

.custom-table :deep(th) {
    background-color: #f8fafc;
    color: #475569;
    font-weight: 600;
}

.custom-table :deep(.el-table__cell) {
    padding: 5px 0;
}

.custom-table :deep(.cell) {
    line-height: 20px;
}

.table-actions {
    display: grid;
    grid-template-columns: repeat(2, 68px);
    gap: 6px;
    justify-content: center;
    align-items: center;
}

.table-actions .el-button {
    width: 68px;
    margin: 0;
    padding-left: 0;
    padding-right: 0;
}

.table-upload-action,
.table-upload-action :deep(.el-upload) {
    width: 68px;
    display: block;
}

.table-upload-action :deep(.el-button) {
    width: 68px;
}

.branch-card-grid {
    padding: 8px 14px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 8px;
}

.diag-mode-value {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.diag-mode-help {
    color: #409eff;
    cursor: help;
    font-size: 15px;
}

.branch-card {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    padding: 8px 10px;
    background: #f8fafc;
    border: 1px solid #e4eaf2;
    border-radius: 8px;
}

.branch-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px 12px;
}

.branch-row {
    min-width: 0;
}

.branch-row span {
    display: block;
    color: #64748b;
    font-size: 12px;
    line-height: 1.3;
}

.branch-row strong {
    display: block;
    margin-top: 2px;
    color: #1e293b;
    font-size: 13px;
    line-height: 1.25;
    font-weight: 700;
    overflow-wrap: anywhere;
}

/* ========== 手机端样式 ========== */
.mobile-view {
    padding: 12px;
    background-color: #eef2f6;
    min-height: 100vh;
    padding-bottom: 80px;
}

/* 搜索卡片 */
.mobile-search-card {
    background: white;
    border: 1px solid #dbe3ee;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.mobile-search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.mobile-title {
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
}

.server-tag {
    background: #ecfdf3 !important;
    color: #027a48 !important;
    border: none;
    font-weight: 700;
}

.mobile-search-box {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
}

.mobile-search-input {
    flex: 1;
}

.mobile-search-input :deep(.el-input__wrapper) {
    border-radius: 6px;
    background: #f8fafc;
    box-shadow: 0 0 0 1px #cfd8e3 inset;
}

.mobile-search-btn {
    border-radius: 6px;
    padding: 8px 20px;
}

.mobile-tabs {
    display: flex;
    gap: 8px;
}

.mobile-tabs .el-button {
    flex: 1;
    border-radius: 6px;
}

/* 统计卡片网格 */
.mobile-stats-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-bottom: 12px;
}

.mobile-stat-card {
    background: white;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
    border: 1px solid #dbe3ee;
    min-width: 0;
}

.mobile-stat-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: #eff6ff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #175cd3;
    flex: 0 0 auto;
}

.mobile-stat-content {
    flex: 1;
    min-width: 0;
}

.mobile-stat-label {
    font-size: 11px;
    color: #64748b;
    display: block;
    margin-bottom: 2px;
}

.mobile-stat-value {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text-success {
    color: #61bc84;
}

.text-error {
    color: #fd5732;
}

/* 操作按钮栏 */
.mobile-action-bar {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}

.mobile-action-bar .el-button {
    width: 100%;
    border-radius: 6px;
    margin-left: 0;
}

.mobile-action-bar :deep(.el-upload) {
    width: 100%;
}

/* 数据卡片 */
.mobile-data-section {
    background: white;
    border: 1px solid #dbe3ee;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.mobile-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
}

.header-actions {
    display: flex;
    gap: 8px;
}

.mobile-data-card {
    border: 1px solid #e4eaf2;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fff;
}

.mobile-data-card:last-child {
    margin-bottom: 0;
}

.mobile-data-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.mobile-vin {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    overflow-wrap: anywhere;
}

.mobile-data-content {
    background: #f8fafc;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 8px;
}

.mobile-data-row {
    display: flex;
    padding: 4px 0;
    font-size: 13px;
}

.mobile-data-label {
    width: 60px;
    color: #64748b;
    flex: 0 0 auto;
}

.mobile-data-value {
    flex: 1;
    color: #1e293b;
    overflow-wrap: anywhere;
}

.mobile-data-actions {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}

.mobile-data-actions .el-button {
    flex: 1;
    padding: 6px 0;
    margin-left: 0;
}

/* 空状态 */
.mobile-empty {
    padding: 20px 0;
}

/* 信息卡片 */
.mobile-info-card {
    background: #f8fafc;
    border: 1px solid #e4eaf2;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 8px;
}

.mobile-info-row {
    display: flex;
    padding: 6px 0;
    font-size: 13px;
}

.mobile-info-label {
    width: 80px;
    color: #64748b;
}

.mobile-info-value {
    flex: 1;
    color: #1e293b;
    overflow-wrap: anywhere;
}

/* 命令卡片 */
.mobile-command-card {
    background: #f8fafc;
    border: 1px solid #e4eaf2;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 8px;
}

.command-row {
    display: flex;
    padding: 4px 0;
    font-size: 13px;
}

.command-label {
    width: 70px;
    color: #64748b;
}

.command-value {
    flex: 1;
    color: #1e293b;
    overflow-wrap: anywhere;
}

/* 弹窗样式 */
.custom-dialog :deep(.el-dialog) {
    border-radius: 20px;
}

.custom-dialog :deep(.el-dialog__header) {
    padding: 20px;
    border-bottom: 1px solid #f1f5f9;
}

.custom-dialog :deep(.el-dialog__body) {
    padding: 24px;
}

.custom-dialog :deep(.el-dialog__footer) {
    padding: 16px 20px;
    border-top: 1px solid #f1f5f9;
}

.not-match-filter-dialog :deep(.el-dialog) {
    border-radius: 12px;
}

.not-match-filter-dialog :deep(.el-dialog__body) {
    padding-top: 12px;
}

.not-match-filter-tip {
    margin-bottom: 18px;
}

.not-match-filter-footer {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
}

.not-match-filter-footer .el-button {
    margin-left: 0;
}

/* 响应式 */
@media screen and (max-width: 1280px) {
    .desktop-toolbar {
        grid-template-columns: auto minmax(280px, 1fr);
    }

    .toolbar-tools {
        grid-column: 1 / -1;
        justify-content: flex-start;
    }

    .stats-grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .stat-card:nth-child(4n) {
        border-right: 0;
    }

    .stat-card:nth-child(n + 5) {
        border-top: 1px solid #e4eaf2;
    }
}

@media screen and (max-width: 768px) {
    .desktop-toolbar,
    .desktop-workspace {
        display: none;
    }

    .data-container {
        padding: 0;
    }
}

@media screen and (max-width: 420px) {
    .mobile-action-bar {
        grid-template-columns: 1fr;
    }

    .mobile-search-box {
        grid-template-columns: minmax(0, 1fr) 68px;
    }
}

@media screen and (min-width: 769px) {
    .mobile-view {
        display: none;
    }
}

/* 滚动条美化 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
}

::-webkit-scrollbar-track {
    background: #f1f5f9;
}

/* ── Dark-mode tonal buttons ── */
:global(html.dark .main-container .el-button--primary) {
    color: var(--wf-status-info-text) !important;
    border-color: rgba(96, 165, 250, 0.46) !important;
    background: var(--wf-status-info-bg) !important;
    box-shadow: none !important;
}
:global(html.dark .main-container .el-button--primary:not(.is-disabled):hover),
:global(html.dark .main-container .el-button--primary:not(.is-disabled):focus) {
    color: #dbeafe !important;
    border-color: rgba(96, 165, 250, 0.7) !important;
    background: rgba(59, 130, 246, 0.24) !important;
}
:global(html.dark .main-container .el-button--success) {
    color: var(--wf-status-success-text) !important;
    border-color: rgba(52, 211, 153, 0.42) !important;
    background: var(--wf-status-success-bg) !important;
    box-shadow: none !important;
}
:global(html.dark .main-container .el-button--success:not(.is-disabled):hover),
:global(html.dark .main-container .el-button--success:not(.is-disabled):focus) {
    color: #a7f3d0 !important;
    border-color: rgba(52, 211, 153, 0.68) !important;
    background: rgba(16, 185, 129, 0.24) !important;
}
:global(html.dark .main-container .el-button--warning) {
    color: var(--wf-status-warning-text) !important;
    border-color: rgba(252, 211, 77, 0.42) !important;
    background: var(--wf-status-warning-bg) !important;
    box-shadow: none !important;
}
:global(html.dark .main-container .el-button--warning:not(.is-disabled):hover),
:global(html.dark .main-container .el-button--warning:not(.is-disabled):focus) {
    color: #fde68a !important;
    border-color: rgba(252, 211, 77, 0.68) !important;
    background: rgba(245, 158, 11, 0.24) !important;
}
:global(html.dark .main-container .el-button--danger) {
    color: var(--wf-status-danger-text) !important;
    border-color: rgba(248, 113, 113, 0.42) !important;
    background: var(--wf-status-danger-bg) !important;
    box-shadow: none !important;
}
:global(html.dark .main-container .el-button--danger:not(.is-disabled):hover),
:global(html.dark .main-container .el-button--danger:not(.is-disabled):focus) {
    color: #fecaca !important;
    border-color: rgba(248, 113, 113, 0.68) !important;
    background: rgba(239, 68, 68, 0.24) !important;
}
:global(html.dark .main-container .el-button--info) {
    color: #94a3b8 !important;
    border-color: rgba(148, 163, 184, 0.36) !important;
    background: rgba(148, 163, 184, 0.12) !important;
    box-shadow: none !important;
}
:global(html.dark .main-container .el-button--info:not(.is-disabled):hover),
:global(html.dark .main-container .el-button--info:not(.is-disabled):focus) {
    color: #cbd5e1 !important;
    border-color: rgba(148, 163, 184, 0.6) !important;
    background: rgba(148, 163, 184, 0.22) !important;
}
:global(html.dark .main-container .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):not(.el-button--info)) {
    color: var(--wf-text-regular) !important;
    border-color: var(--wf-control-border) !important;
    background: var(--wf-surface-soft) !important;
    box-shadow: none !important;
}
:global(html.dark .main-container .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):not(.el-button--info):not(.is-disabled):hover),
:global(html.dark .main-container .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):not(.el-button--info):not(.is-disabled):focus) {
    color: var(--wf-text-primary) !important;
    border-color: #64748b !important;
    background: var(--wf-hover-bg) !important;
}
:global(html.dark .main-container .el-button.is-disabled) {
    opacity: 0.58;
    box-shadow: none !important;
}
</style>
